import type { StateCreator } from 'zustand';
import type { StoreType, DatasetSlice } from '@/types/store';

export const createDatasetSlice: StateCreator<StoreType, [], [], DatasetSlice> = (set, get) => ({
  dataset: null,

  loadDataset: (dataset) => set({ dataset }),

  setGroupBy: (keys) => {
    const current = get().dataset;
    if (!current) return;
    set({ dataset: { ...current, groupBy: keys } });
  },
});
